import { useLocalServer } from '../../context/LocalServerContext';

/**
 * Visible only once a local server has been seen available this session — the
 * probe always tries localhost:3001, so "unavailable" is the normal state for
 * every restaurant that never deployed one; showing it permanently would just
 * be noise. Once seen, it stays visible so a mid-shift disconnect (falling
 * back to cloud-dependent mode) is caught at a glance, not just via the toast.
 */
export default function LocalServerBadge() {
    const { isAvailable, hasEverConnected } = useLocalServer();

    if (!hasEverConnected) return null;

    return (
        <div
            className="flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium"
            title={
                isAvailable
                    ? 'Serveur local actif — catalogue, caisse et employés fonctionnent sans internet. Les commandes en salle nécessitent toujours internet.'
                    : 'Serveur local injoignable — mode cloud (dégradé, pas une panne). Internet reste nécessaire pour les commandes.'
            }
        >
            {/* Cloud = repli normal vers le mode habituel, pas une panne : ambre plutôt que
                rouge (réservé à une vraie panne, ex. si le cloud lui-même devenait injoignable). */}
            <span
                className={`inline-block w-2 h-2 rounded-full ${isAvailable ? 'bg-green-500' : 'bg-amber-500'}`}
            />
            <span className={isAvailable ? 'text-green-600' : 'text-amber-600'}>
                {isAvailable ? 'Local' : 'Cloud'}
            </span>
        </div>
    );
}
